import Reveal from '@/components/base/Reveal';
import { featuredDigs } from '@/mocks/home';

export default function FeaturedDigs() {
  return (
    <section id="featured" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="flex flex-col gap-4 border-b border-background-200 pb-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
                <span className="h-px w-8 bg-primary-500" />
                精选深挖
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                值得花时间读的三篇解析
              </h2>
            </div>
            <a
              href="#collections"
              className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              查看全部深挖
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featuredDigs.map((dig, i) => (
            <Reveal key={dig.id} delay={i * 90} className="h-full">
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-foreground-300">
                <div className="relative h-52 w-full overflow-hidden bg-background-200">
                  <img
                    src={dig.image}
                    alt={`${dig.title} - 黑料一区深挖解析配图`}
                    title={`${dig.title} - 黑料一区内幕分析`}
                    className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                  <span className="absolute left-3 top-3 rounded bg-background-50/95 px-2.5 py-1 text-xs font-medium text-foreground-800">
                    {dig.tag}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg font-semibold leading-snug text-foreground-950">
                    <a href="#featured" className="transition-colors hover:text-primary-600">
                      {dig.title}
                    </a>
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{dig.summary}</p>

                  <div className="mt-5 flex items-center gap-4 border-t border-background-100 pt-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line text-sm" />
                      {dig.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-sm" />
                      {dig.views}
                    </span>
                    <span className="ml-auto font-mono">{dig.date}</span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}